import { buildEndpoint } from '../helpers/BuildEndpoint';
import BasePaths from './BasePaths';

const minbankBaseUrl = BasePaths.MinBank;

const oddPathDefinitions = {
  form: '/odd/v1/odd/form',
};

const oddEndpoints = {
  form: () => buildEndpoint(minbankBaseUrl, oddPathDefinitions.form),
};

export { oddEndpoints, oddPathDefinitions };
